import { debounce } from "@evergis/sgis/es/utils/utils";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SimpleOffset } from "../../../interfaces/style";

type AnchorPoint = {
  x: number;
  y: number;
};

const offsetToAnchorPoint = ([x, y]: SimpleOffset): AnchorPoint => ({ x, y });

export function useAnchorPoint(symbolOffset: SimpleOffset | undefined, onOffsetChange: (offset: SimpleOffset) => void) {
  const offsetFromAnchorPoint = useMemo(
    () => (symbolOffset ? offsetToAnchorPoint(symbolOffset) : undefined),
    [symbolOffset && symbolOffset[0], symbolOffset && symbolOffset[1]],
  );

  const [anchorPoint, setAnchorPoint] = useState<AnchorPoint | undefined>(offsetFromAnchorPoint);

  const handleOffsetChange = useMemo(() => debounce(onOffsetChange, 300), [onOffsetChange]);

  const handleSetAnchorPoint = useCallback(
    (currentOffset: SimpleOffset | AnchorPoint) => {
      const newOffset: SimpleOffset = Array.isArray(currentOffset) ? currentOffset : [currentOffset.x, currentOffset.y];

      setAnchorPoint(offsetToAnchorPoint(newOffset));
      handleOffsetChange(newOffset);
    },
    [setAnchorPoint, handleOffsetChange],
  );

  useEffect(() => {
    if (offsetFromAnchorPoint) {
      setAnchorPoint(offsetFromAnchorPoint);
    }
  }, [offsetFromAnchorPoint]);

  return [anchorPoint, handleSetAnchorPoint] as const;
}
